import {connect} from "react-redux";
import Tasks from "../components/Tasks";
import * as VideoActions from '../store/actions/videoActions';
import { withRouter } from 'react-router-dom';

const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.chat,
    ...state.video
});

const mapDispatchToProps = (dispatch) => ({
    onLoad: (profileId, courseId, token) => {
        if(courseId){
            dispatch(VideoActions.getUserCourseContent(courseId, token));
        }
        dispatch(VideoActions.getCourseUser(profileId, token));

    },
    createLog: (log, token) => {
        dispatch(VideoActions.createLog(log, token));
    },
    updateLog: (log, token) => {
        dispatch(VideoActions.updateLog(log, token));
    },
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Tasks));


// WEBPACK FOOTER //
// ./src/containers/TaskContainer.js